module.exports = __webpack_public_path__ + "static/media/kotte-hit.528cc066.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/kotte-hit.png
// module id = 37
// module chunks = 0